module.exports = __webpack_public_path__ + "static/media/dealerplate_california.8b1b8ca9.ttf";